import { graphql } from "gatsby";
import React from "react";
import {
	ParagraphAlignedImageAndText,
	getParagraphAlignedImageAndTextProps,
} from "../ParagraphAlignedImageAndText/ParagraphAlignedImageAndText";
import ParagraphButton, {
	getParagraphButtonProps,
} from "../ParagraphButton/ParagraphButton";
import ParagraphCAQ, {
	getParagraphCAQProps,
} from "../ParagraphCAQ/ParagraphCAQ";
import ParagraphCaseStudy, {
	getParagraphCaseStudyProps,
} from "../ParagraphCaseStudy/ParagraphCaseStudy";
import ParagraphCheckList, {
	getParagraphChecklistProps,
} from "../ParagraphChecklist/ParagraphChecklist";
import ParagraphContactBlock, {
	getParagraphContactBlockProps,
} from "../ParagraphContactBlock/ParagraphContactBlock";
import ParagraphContactUs, {
	getParagraphContactUsProps,
} from "../ParagraphContactUs/ParagraphContactUs";
import ParagraphContentReferenceArticles, {
	getParagraphContentReferenceArticlesProps,
} from "../ParagraphContentReferenceArticles/ParagraphContentReferenceArticles";
import {
	ParagraphContentSection,
	getParagraphContentSectionProps,
} from "../ParagraphContentSection/ParagraphContentSection";
import ParagraphDogSizes, {
	getParagraphDogSizesProps,
} from "../ParagraphDogSizes/ParagraphDogSizes";
import ParagraphExternalSignpostLink, {
	getParagraphExternalSignpostLinkProps,
} from "../ParagraphExternalSignpostLink/ParagraphExternalSignpostLink";
import ParagraphFAQ, {
	getParagraphFAQProps,
} from "../ParagraphFAQ/ParagraphFAQ";
import {
	ParagraphFileDownload,
	getParagraphFileDownloadProps,
} from "../ParagraphFileDownload/ParagraphFileDownload";
import {
	ParagraphGroupOfExpandableSections,
	getParagraphGroupOfExpandableSectionsProps,
} from "../ParagraphGroupOfExpandableSections/ParagraphGroupOfExpandableSections";
import ParagraphHighlightedQuotes, {
	getParagraphHighlightedQuotesProps,
} from "../ParagraphHighlightedQuotes/ParagraphHighlightedQuotes";
import ParagraphHighlightedTextArea, {
	getParagraphHighlightedTextAreaProps,
} from "../ParagraphHighlightedTextArea/ParagraphHighlightedTextArea";
import ParagraphImages, {
	getParagraphImagesProps,
} from "../ParagraphImages/ParagraphImages";
import ParagraphJumpLinks, {
	getParagraphJumpLinksProps,
} from "../ParagraphJumpLinks/ParagraphJumpLinks";
import ParagraphKeyFactsFigures, {
	getParagraphKeyFactsFiguresProps,
} from "../ParagraphKeyFactsFigures/ParagraphKeyFactsFigures";
import ParagraphMediaContentList, {
	getParagraphMediaContentListProps,
} from "../ParagraphMediaContentList/ParagraphMediaContentList";
import {
	ParagraphMissionStatement,
	getParagraphMissionStatementProps,
} from "../ParagraphMissionStatement/ParagraphMissionStatement";
import ParagraphNationalDogSurveyCta, {
	getParagraphNationalDogSurveyCtaProps,
} from "../ParagraphNationalDogSurveyCta/ParagraphNationalDogSurveyCta";
import ParagraphPopularTopics, {
	getParagraphPopularTopicsProps,
} from "../ParagraphPopularTopics/ParagraphPopularTopics";
import ParagraphQuote, {
	getParagraphQuoteProps,
} from "../ParagraphQuote/ParagraphQuote";
import {
	ParagraphSection,
	getParagraphSectionProps,
} from "../ParagraphSection/ParagraphSection";
import ParagraphShareableCarousel, {
	getParagraphShareableCarouselProps,
} from "../ParagraphShareableCarousel/ParagraphShareableCarousel";
import {
	ParagraphSponsorMePromoCard,
	getParagraphSponsorMePromoCardProps,
} from "../ParagraphSponsorMePromoCard/ParagraphSponsorMePromoCard";
import ParagraphSteppedProcess, {
	getParagraphSteppedProcessProps,
} from "../ParagraphSteppedProcess/ParagraphSteppedProcess";
import {
	ParagraphSuccessStories,
	getParagraphSuccessStoriesProps,
} from "../ParagraphSuccessStories/ParagraphSuccessStories";
import ParagraphSupportCards, {
	getParagraphSupportCardsProps,
} from "../ParagraphSupportCards/ParagraphSupportCards";
import ParagraphSupportWidget, {
	getParagraphSupportWidgetProps,
} from "../ParagraphSupportWidget/ParagraphSupportWidget";
import ParagraphSupportWidgetPrimary, {
	getParagraphSupportWidgetPrimaryProps,
} from "../ParagraphSupportWidgetPrimary/ParagraphSupportWidgetPrimary";
import {
	ParagraphTextAndImage,
	getParagraphTextAndImageProps,
} from "../ParagraphTextAndImage/ParagraphTextAndImage";
import ParagraphTextArea, {
	getParagraphTextAreaProps,
} from "../ParagraphTextArea/ParagraphTextArea";
import ParagraphTextWithArticles, {
	getParagraphTextWithArticlesProps,
} from "../ParagraphTextWithArticles/ParagraphTextWithArticles";
import ParagraphVideo, {
	getParagraphVideoProps,
} from "../ParagraphVideo/ParagraphVideo";

interface ParagraphContentSectionProps {
	data: Queries.ParagraphSectionsDataFragment;
	thisSectionKey: number;
	forceFlatCards?: boolean;
	isHomePage?: boolean;
	noBreaks?: boolean;
}
export const ParagraphSections: React.FC<ParagraphContentSectionProps> = ({
	data,
	forceFlatCards = false,
	isHomePage = false,
}) => {
	const { __typename, ...props } = data;
	switch (__typename) {
		case "paragraph__section":
			return (
				<ParagraphSection
					{...getParagraphSectionProps(
						{
							...props,
							__typename,
						} as Queries.ParagraphSectionDataFragment,
						forceFlatCards,
						isHomePage,
					)}
				/>
			);

		case "paragraph__textarea":
			return (
				<ParagraphTextArea
					{...getParagraphTextAreaProps(
						props as Queries.ParagraphTextAreaDataFragment,
					)}
				/>
			);
		case "paragraph__contact_us":
			return (
				<ParagraphContactUs
					{...getParagraphContactUsProps(
						props as Queries.ParagraphContactUsDataFragment,
					)}
				/>
			);
		case "paragraph__commonly_asked_question_section":
			return (
				<ParagraphCAQ
					{...getParagraphCAQProps(props as Queries.ParagraphCAQDataFragment)}
				/>
			);
		case "paragraph__video":
			return (
				<ParagraphVideo
					{...getParagraphVideoProps(
						props as Queries.ParagraphVideoDataFragment,
					)}
				/>
			);
		case "paragraph__checklist":
			return (
				<ParagraphCheckList
					{...getParagraphChecklistProps(
						props as Queries.ParagraphChecklistDataFragment,
					)}
				/>
			);
		case "paragraph__quote":
			return (
				<ParagraphQuote
					{...getParagraphQuoteProps(
						props as Queries.ParagraphQuoteDataFragment,
					)}
				/>
			);
		case "paragraph__image":
			return (
				<ParagraphImages
					{...getParagraphImagesProps(
						props as Queries.ParagraphImagesDataFragment,
					)}
				/>
			);
		case "paragraph__stepped_process":
			return (
				<ParagraphSteppedProcess
					{...getParagraphSteppedProcessProps(
						props as Queries.ParagraphSteppedProcessDataFragment,
					)}
				/>
			);
		case "paragraph__support_cards":
			return (
				<ParagraphSupportCards
					{...getParagraphSupportCardsProps(
						props as Queries.ParagraphSupportCardsDataFragment,
					)}
				/>
			);

		case "paragraph__content_reference_articles":
			return (
				<ParagraphContentReferenceArticles
					{...getParagraphContentReferenceArticlesProps(
						props as Queries.ParagraphContentReferenceArticlesDataFragment,
					)}
				/>
			);
		case "paragraph__link_button":
			return (
				<ParagraphButton
					{...getParagraphButtonProps(
						props as Queries.ParagraphButtonDataFragment,
						true,
					)}
				/>
			);
		case "paragraph__popular_topics":
			return (
				<ParagraphPopularTopics
					{...getParagraphPopularTopicsProps(
						props as Queries.ParagraphPopularTopicsDataFragment,
					)}
				/>
			);
		case "paragraph__external_signpost_link":
			return (
				<ParagraphExternalSignpostLink
					{...getParagraphExternalSignpostLinkProps(
						props as Queries.ParagraphExternalSignpostLinkDataFragment,
					)}
				/>
			);
		case "paragraph__text_with_articles":
			return (
				<ParagraphTextWithArticles
					{...getParagraphTextWithArticlesProps(
						props as Queries.ParagraphTextWithArticlesDataFragment,
					)}
				/>
			);
		case "paragraph__success_stories":
			return (
				<ParagraphSuccessStories
					{...getParagraphSuccessStoriesProps(
						props as Queries.ParagraphSuccessStoriesDataFragment,
					)}
				/>
			);
		case "paragraph__faqs":
			return (
				<ParagraphFAQ
					{...getParagraphFAQProps(props as Queries.ParagraphFAQsDataFragment)}
				/>
			);
		case "paragraph__file_download":
			return (
				<ParagraphFileDownload
					{...getParagraphFileDownloadProps(
						props as Queries.ParagraphFileDownloadDataFragment,
					)}
				/>
			);
		case "paragraph__highlighted_text_area":
			return (
				<ParagraphHighlightedTextArea
					{...getParagraphHighlightedTextAreaProps(
						props as Queries.ParagraphHighlightedTextAreaDataFragment,
					)}
				/>
			);
		case "paragraph__sponsor_me_promo_card":
			return (
				<ParagraphSponsorMePromoCard
					{...getParagraphSponsorMePromoCardProps(
						props as Queries.ParagraphSponsorMePromoCardDataFragment,
					)}
				/>
			);
		case "paragraph__text_and_image":
			return (
				<ParagraphTextAndImage
					{...getParagraphTextAndImageProps(
						props as Queries.ParagraphTextAndImageDataFragment,
					)}
				/>
			);
		case "paragraph__support_widget":
			return (
				<ParagraphSupportWidget
					{...getParagraphSupportWidgetProps(
						props as Queries.ParagraphSupportWidgetDataFragment,
					)}
				/>
			);
		case "paragraph__support_widget_primary":
			return (
				<ParagraphSupportWidgetPrimary
					{...getParagraphSupportWidgetPrimaryProps(
						props as Queries.ParagraphSupportWidgetPrimaryDataFragment,
					)}
				/>
			);
		case "paragraph__contact_component_block":
			return (
				<ParagraphContactBlock
					{...getParagraphContactBlockProps(
						props as Queries.ParagraphContactBlockDataFragment,
					)}
				/>
			);
		case "paragraph__highlighted_quotes":
			return (
				<ParagraphHighlightedQuotes
					{...getParagraphHighlightedQuotesProps(
						props as Queries.ParagraphHighlightedQuotesDataFragment,
					)}
				/>
			);
		case "paragraph__media_content_list":
			return (
				<ParagraphMediaContentList
					{...getParagraphMediaContentListProps(
						props as Queries.ParagraphMediaContentListDataFragment,
					)}
				/>
			);
		case "paragraph__content_section":
			return (
				<ParagraphContentSection
					{...getParagraphContentSectionProps(
						data as Queries.ParagraphContentSectionDataFragment,
						false,
					)}
				/>
			);

		case "paragraph__centre_aligned_content_section":
			return (
				<ParagraphContentSection
					{...getParagraphContentSectionProps(
						data as Queries.ParagraphSectionsData_paragraph__centre_aligned_content_section_Fragment,
						true,
					)}
				/>
			);

		case "paragraph__aligned_image_and_text":
			return (
				<ParagraphAlignedImageAndText
					{...getParagraphAlignedImageAndTextProps(
						props as Queries.ParagraphAlignedImageAndTextDataFragment,
					)}
				/>
			);
		case "paragraph__key_facts_figures":
			return (
				<ParagraphKeyFactsFigures
					{...getParagraphKeyFactsFiguresProps(
						props as Queries.ParagraphKeyFactsFiguresDataFragment,
					)}
				/>
			);
		case "paragraph__mission_statement":
			return (
				<ParagraphMissionStatement
					{...getParagraphMissionStatementProps(
						props as Queries.ParagraphMissionStatementDataFragment,
					)}
				/>
			);
		case "paragraph__case_study":
			return (
				<ParagraphCaseStudy
					{...getParagraphCaseStudyProps(
						props as Queries.ParagraphCaseStudyDataFragment,
					)}
				/>
			);
		case "paragraph__national_dog_survey_cta":
			return (
				<ParagraphNationalDogSurveyCta
					{...getParagraphNationalDogSurveyCtaProps(
						props as Queries.ParagraphNationalDogSurveyCtaDataFragment,
					)}
				/>
			);

		case "paragraph__group_of_expandable_sections":
			return (
				<ParagraphGroupOfExpandableSections
					{...getParagraphGroupOfExpandableSectionsProps(
						props as Queries.ParagraphGroupOfExpandableSectionsDataFragment,
					)}
				/>
			);

		case "paragraph__dog_sizes":
			return (
				<ParagraphDogSizes
					{...getParagraphDogSizesProps(
						props as Queries.ParagraphDogSizesDataFragment,
					)}
				/>
			);

		case "paragraph__jump_links":
			return (
				<ParagraphJumpLinks
					{...getParagraphJumpLinksProps(
						props as Queries.ParagraphJumpLinksDataFragment,
					)}
				/>
			);
		case "paragraph__shareable_carousel":
			return (
				<ParagraphShareableCarousel
					{...getParagraphShareableCarouselProps(
						props as Queries.ParagraphShareableCarouselDataFragment,
					)}
				/>
			);

		default:
			// Adding noise to builds, turn on if needed
			// console.warn(`Unknown Section Type: ${__typename}`, props);
			return null;
	}
};

export default ParagraphSections;
export const fragment = graphql`
    fragment ParagraphSectionsData on ParagraphSections {
        __typename
        ...ParagraphSectionData
        ...ParagraphContentSectionUnionData
        ...ParagraphCAQData
        ...ParagraphContactUsData
        ...ParagraphImagesData
        ...ParagraphTextAreaData
        ...ParagraphVideoData
        ...ParagraphChecklistData
        ...ParagraphQuoteData
        ...ParagraphSteppedProcessData
        ...ParagraphContentReferenceArticlesData
        ...ParagraphButtonData
        ...ParagraphPopularTopicsData
        ...ParagraphExternalSignpostLinkData
        ...ParagraphSupportCardsData
        ...ParagraphTextWithArticlesData
        ...ParagraphSuccessStoriesData
        ...ParagraphFAQsData
        ...ParagraphFileDownloadData
        ...ParagraphHighlightedTextAreaData
        ...ParagraphSponsorMePromoCardData
        ...ParagraphTextAndImageData
        ...ParagraphSupportWidgetData
        ...ParagraphSupportWidgetPrimaryData
        ...ParagraphContactBlockData
        ...ParagraphHighlightedQuotesData
        ...ParagraphMediaContentListData
        ...ParagraphAlignedImageAndTextData
		...ParagraphGroupOfExpandableSectionsData
		...ParagraphKeyFactsFiguresData
		...ParagraphMissionStatementData
		...ParagraphCaseStudyData
		...ParagraphNationalDogSurveyCtaData
		...ParagraphDogSizesData
		...ParagraphJumpLinksData
		...ParagraphShareableCarouselData
    }
`;
